export default shape_designer.figure.DecoratedOutputPort = draw2d.OutputPort.extend({

  init: function (attr, setter, getter) {
    this._super(attr, setter, getter)
  }
})
